import { isServer } from '@flyer/utils';
import createClient from 'openapi-fetch';
import type { paths } from '../__generated__/openapi-v4';

/**
 * Client REST v4 (student), gõ theo spec OpenAPI.
 *
 * Trên browser gọi qua chính origin của app (`/api/v4/...`, rewrite trong next.config.mjs)
 * để cookie session được gửi kèm như Apollo đang làm với `/api/v2/graphql`. Gọi thẳng
 * staging-api.flyer.us từ browser là cookie cross-site, sẽ mất session.
 *
 * Trên server không có rewrite nên phải là URL đầy đủ. Biến FLYER_BACKEND_V4_API là
 * server-only (không có tiền tố NEXT_PUBLIC_), đúng như bên partner-web.
 *
 * LƯU Ý host: v4/student CHỈ có ở .us — https://staging-api.flyer.vn/v4/student/openapi.json
 * trả 404. Đừng thay bằng NEXT_PUBLIC_APP_API (đang trỏ .vn).
 */
const BASE_URL = isServer()
  ? process.env.FLYER_BACKEND_V4_API || 'https://staging-api.flyer.us'
  : '/api';

export const apiClientV4 = createClient<paths>({
  baseUrl: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    device: 'WEB_RANKING',
  },
  // Session của student nằm ở cookie, không phải bearer token.
  credentials: 'include',
});

apiClientV4.use({
  async onResponse({ response }) {
    if (!response.ok) {
      console.error('API v4 Error:', response.status, response.statusText, response.url);
    }
    return response;
  },
});

export default apiClientV4;
